'use client';

import { HStack, Input, Separator, Stack } from '@chakra-ui/react';
import { NavigateBar } from '../components/NavigateBar';
import { Field } from '../components/ui/field';
import { Radio, RadioGroup } from '../components/ui/radio';
import { Text } from '../components/Text';
import { _Bool, useStore } from '../store';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const General = () => {
    const { t } = useTranslation();
    const {
        email,
        bank,
        since,
        oldestTransactionDate,
        sessionWarning,
        allowCredentials,
        allowTesting,
        twoFaAvailable,
        twoFaAvailableTransaction,
        captchaDetection,
        twoFaList,
        note,
        setEmail,
        setBank,
        setSince,
        setOldestTransactionDate,
        setSessionWarning,
        setAllowCredentials,
        setAllowTesting,
        setTwoFaAvailable,
        setTwoFaAvailableTransaction,
        setCaptchaDetection,
        setTwoList,
        setNote,
    } = useStore();
    const [invalidFields, setInvalidFields] = useState({ email: false, bank: false, since: false });

    const checkDataInput = (): boolean => {
        const _invalid = { email: !email, bank: !bank, since: !since };
        setInvalidFields(_invalid);
        return !(_invalid.email || _invalid.bank || _invalid.since);
    };

    return (
        <>
            <Stack spaceY={4}>
                <Text trans="generalScreen.description" />
                <Field
                    label="generalScreen.email"
                    invalid={invalidFields.email}
                    required
                    errorText={t('generalScreen.requiedField')}
                >
                    <Input
                        name="email"
                        type="email"
                        value={email}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                    />
                </Field>
                <Field
                    label="generalScreen.bank"
                    invalid={invalidFields.bank}
                    required
                    errorText={t('generalScreen.requiedField')}
                >
                    <Input
                        name="bank"
                        type="text"
                        value={bank}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setBank(e.target.value)}
                    />
                </Field>
                <Separator />
                <Field
                    label="generalScreen.sinceDate"
                    invalid={invalidFields.since}
                    required
                    errorText={t('generalScreen.requiedField')}
                >
                    <Input
                        name="since"
                        type="date"
                        value={since}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSince(e.target.value)}
                    />
                </Field>
                <Field label="generalScreen.oldestDate">
                    <Input
                        name="oldestTransactionDate"
                        type="date"
                        value={oldestTransactionDate}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setOldestTransactionDate(e.target.value)}
                    />
                </Field>
                <Separator />
                <RadioGroup
                    value={twoFaAvailable}
                    onValueChange={(e: any) => {
                        setTwoFaAvailable(e.value as _Bool);
                    }}
                >
                    <Text trans="generalScreen.twoFaAvailable" />
                    <HStack gap="6" mt={2}>
                        <Radio value={_Bool.true}>
                            <Text trans="yes" />
                        </Radio>
                        <Radio value={_Bool.false}>
                            <Text trans="no" />
                        </Radio>
                    </HStack>
                </RadioGroup>
                <RadioGroup
                    value={twoFaAvailableTransaction}
                    onValueChange={(e: any) => {
                        setTwoFaAvailableTransaction(e.value as _Bool);
                    }}
                >
                    <Text trans="generalScreen.twoFaAvailableTransaction" />
                    <HStack gap="6" mt={2}>
                        <Radio value={_Bool.true}>
                            <Text trans="yes" />
                        </Radio>
                        <Radio value={_Bool.false}>
                            <Text trans="no" />
                        </Radio>
                    </HStack>
                </RadioGroup>

                <RadioGroup
                    value={captchaDetection}
                    onValueChange={(e: any) => {
                        setCaptchaDetection(e.value as _Bool);
                    }}
                >
                    <Text trans="generalScreen.captchaDetection" />
                    <HStack gap="6" mt={2}>
                        <Radio value={_Bool.true}>
                            <Text trans="yes" />
                        </Radio>
                        <Radio value={_Bool.false}>
                            <Text trans="no" />
                        </Radio>
                    </HStack>
                </RadioGroup>
                <Field label="generalScreen.twoFaList">
                    <Input
                        name="twoFaList"
                        type="text"
                        value={twoFaList}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setTwoList(e.target.value)}
                    />
                </Field>
                <Separator />
                <RadioGroup
                    value={sessionWarning}
                    onValueChange={(e: any) => {
                        setSessionWarning(e.value as _Bool);
                    }}
                >
                    <Text trans="generalScreen.sessionWaring" />
                    <HStack gap="6" mt={2}>
                        <Radio value={_Bool.true}>
                            <Text trans="yes" />
                        </Radio>
                        <Radio value={_Bool.false}>
                            <Text trans="no" />
                        </Radio>
                    </HStack>
                </RadioGroup>
                <RadioGroup
                    value={allowCredentials}
                    onValueChange={(e: any) => {
                        setAllowCredentials(e.value as _Bool);
                    }}
                >
                    <Text trans="generalScreen.credentials" />
                    <HStack gap="6" mt={2}>
                        <Radio value={_Bool.true}>
                            <Text trans="yes" />
                        </Radio>
                        <Radio value={_Bool.false}>
                            <Text trans="no" />
                        </Radio>
                    </HStack>
                </RadioGroup>
                <RadioGroup
                    value={allowTesting}
                    onValueChange={(e: any) => {
                        setAllowTesting(e.value as _Bool);
                    }}
                >
                    <Text trans="generalScreen.testing" />
                    <HStack gap="6" mt={2}>
                        <Radio value={_Bool.true}>
                            <Text trans="yes" />
                        </Radio>
                        <Radio value={_Bool.false}>
                            <Text trans="no" />
                        </Radio>
                    </HStack>
                </RadioGroup>
                <Separator />
                <Field label="generalScreen.note">
                    <Input
                        name="note"
                        type="text"
                        value={note}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNote(e.target.value)}
                    />
                </Field>
            </Stack>

            <NavigateBar mt={10} backPath="/personal" continuePath="/fileupload" beforeContinueFn={checkDataInput} />
        </>
    );
};
